var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import styled from "styled-components";
import { Button, Card, ExpandablePanel, Grid, GridColumn, RightDiv, Separator } from "@atlassiansox/microscopekit";
import { FaultInputView } from "./FaultInputView";
import { SteadyStateView } from "./SteadyStateView";
import TrashIcon from "@atlaskit/icon/glyph/trash";
import EditFilledIcon from "@atlaskit/icon/glyph/edit-filled";
export var TaskGroupView = function (_a) {
    var _b, _c;
    var taskGroup = _a.taskGroup, index = _a.index, editFc = _a.editFc, deleteFc = _a.deleteFc, isCollapsedInitially = _a.isCollapsedInitially;
    var _d = __read(useState(isCollapsedInitially), 2), isCollapsed = _d[0], setIsCollapsed = _d[1];
    return (React.createElement(ExpandablePanel, { title: "Task Group # " + (index + 1), isCollapsed: isCollapsed, onToggle: function () {
            setIsCollapsed(!isCollapsed);
        } },
        React.createElement(Container, { hidden: editFc == null || deleteFc == null },
            React.createElement(Separator, null),
            React.createElement(Grid, { spacing: "comfortable" },
                React.createElement(GridColumn, { medium: 8 },
                    React.createElement("h4", null, "Task Group Details")),
                React.createElement(GridColumn, { medium: 4 },
                    React.createElement(RightDiv, null,
                        React.createElement(Button, { onClick: function (event) {
                                if (editFc != null) {
                                    editFc(taskGroup);
                                }
                            } },
                            React.createElement(EditFilledIcon, { label: "Edit" })),
                        React.createElement(Button, { onClick: function (event) {
                                if (deleteFc != null) {
                                    deleteFc(taskGroup);
                                }
                            } },
                            React.createElement(TrashIcon, { label: "Delete" })))))),
        React.createElement(Separator, null),
        React.createElement(React.Fragment, null, Boolean(taskGroup.delayBeforeExecution) && (React.createElement(Container, null,
            "Delay Before Execution: ",
            taskGroup.delayBeforeExecution,
            "s"))),
        React.createElement(Grid, { spacing: "compact" },
            React.createElement(GridColumn, { medium: 6 },
                React.createElement(Card, null,
                    React.createElement("h4", null, "Stop Conditions"),
                    React.createElement(Separator, null), (_b = taskGroup === null || taskGroup === void 0 ? void 0 : taskGroup.steadyStates) === null || _b === void 0 ? void 0 :
                    _b.map(function (steadyState, index) { return (React.createElement(SteadyStateView, { steadyState: steadyState, key: "SteadyStateView:" + index })); }),
                    React.createElement(Card, { hidden: (taskGroup === null || taskGroup === void 0 ? void 0 : taskGroup.steadyStates.length) !== 0 },
                        React.createElement("p", null, "No Stop Conditions added")))),
            React.createElement(GridColumn, { medium: 6 },
                React.createElement(Card, null,
                    React.createElement("h4", null, "Faults"),
                    React.createElement(Separator, null), (_c = taskGroup === null || taskGroup === void 0 ? void 0 : taskGroup.faults) === null || _c === void 0 ? void 0 :
                    _c.map(function (fault, index) { return (React.createElement(FaultInputView, { faultInput: fault, key: "FaultInputView:" + index })); }),
                    React.createElement(Card, { hidden: (taskGroup === null || taskGroup === void 0 ? void 0 : taskGroup.faults.length) !== 0 },
                        React.createElement("p", null, "No faults added")))))));
};
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0 0.5rem;\n"], ["\n  margin: 0 0.5rem;\n"])));
var templateObject_1;
